import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OtpPopupComponent } from 'src/app/components/otp-popup/otp-popup.component';
import { ApiService } from 'src/app/services/api/api.service';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { createIDsValidatorEstate } from 'src/app/services/validators/custom.validators';
import { ValidationService } from 'src/app/services/validators/validation.service';
import { checkTime } from 'src/app/util/Helper';
import { environment } from 'src/environments/environment';
import * as Constants from "src/app/constants/constants";
import { NotificationService } from 'src/app/services/notification.service';
import { ConsentItem, ConsentService } from 'src/app/services/consent/consent.service';
import { ExpansionPanel } from 'src/app/components/section/section.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step1-settlors',
  templateUrl: './step1-settlors.component.html',
  styleUrls: ['./step1-settlors.component.scss']
})
export class Step1SettlorsComponent implements OnInit, AfterViewInit, OnDestroy {
  private formChangesSubscription: Subscription[] = [];
  
  checkerPath: string = `${environment.hRef}assets/fi_check.png`;

  formTitle: string = 'Settlor Information';
  formSubtitle: string = 'A settlor is the person or entity that intends to set up the trust and who prescribes the terms and conditions of the Trust.';

  contactInfoTitle: string = 'Settlor Contact Information';
  detailsTitle: string = 'Settlor Details';
  uploadDocsTitle: string = 'Upload Documents / Photo';

  phoneLabel : string = 'Mobile Number';
  emailLabel : string = 'Email Address';
  emailHint : string = 'Email address';

  titleLabel: string = 'Title';
  titleHint: string = 'Title';
  fNameLabel: string = 'First Name';
  fNameHint : string = 'First name';
  mNameLabel : string = 'Middle Name';
  mNameHint : string = 'Middle name';
  surnameLabel : string = 'Surname';
  surnameHint : string = 'Last name';

  idLabel: string = 'ID/Passport Number';
  idHint: string = 'Enter ID or Passport Number';
  kraPinLabel: string = 'KRA PIN';
  kraPinHint: string = 'Enter KRA PIN';
  addressLabel: string = 'Physical Address';
  addressHint: string = 'Enter Physical address';
  postalLabel: string = 'Postal Address';
  postalHint: string = 'Enter Postal Address';

  idFileLabel: string = 'Upload copy of ID (front + back) / Passport';
  kraFileLabel: string = 'Upload copy of KRA PIN';
  photoLabel: string = 'Upload Passport Photo';

  addSettlorText: string = '+  Add Another Settlor';
  removeSettlorText: string = 'Remove Settlor';

  requiredFieldString: string = 'Required field';

  loadingText: string = 'Requesting OTP';
  loadingRemove: boolean = false;
  currentIndex: number = 0;
  removeButtonText: string = 'Remove';
  consentProvided: boolean = false;

  otpVerified: boolean = false;

  formErrors: { [key: string]: string } = {
    Phone: '',
    SecondaryPhone: '',
    Email: '',
    
    Title: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    IDNo: '',
    KraPin: '',
    Address: '',
    PostalAddress: '',

    IDNoImage: '',
    KraPinImage: '',
    PassportImage: ''
  };

  validationMessages: { [key: string]: {} } = {
    Phone: { required: this.requiredFieldString, pattern:'Invalid phone number', exist: 'This number is tied to an existing settlor' },
    SecondaryPhone: { pattern:'Invalid phone number', exist: 'This number is tied to an existing settlor' },
    Email: { required: this.requiredFieldString, email: "Invalid email address", exist: 'This email is tied to an existing settlor' },

    Title: { required: this.requiredFieldString },
    FirstName: { required: this.requiredFieldString },
    MiddleName: { required: this.requiredFieldString },
    LastName: { required: this.requiredFieldString },
    IDNo:  { required: this.requiredFieldString, min:'Invalid ID or Passport number', exist: 'This ID is tied to an existing settlor' },
    KraPin: { required: this.requiredFieldString, pattern:'Invalid KRA PIN', exist: 'This PIN is tied to an existing settlor' },

    Address: { required: this.requiredFieldString },
    PostalAddress: { required: this.requiredFieldString },

    IDNoImage: { required: this.requiredFieldString },
    KraPinImage: { required: this.requiredFieldString },
    PassportImage: { required: this.requiredFieldString }
  };

  settlorForm = this._formBuilder.group({
    settlors: this._formBuilder.array([
      this.createSettlorsFormGroup()
    ]),
  });

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly notificationService: NotificationService,
    private readonly tabControlService: TabControlService,
    public estateControlService: EstateControlService,
    private readonly validationService: ValidationService,
    private readonly apiService: ApiService,
    private readonly cdr: ChangeDetectorRef,
    private readonly consentService: ConsentService
  ) { }

  async ngOnInit(): Promise<void> {
    this.populateData();
    await this.populateForm();

    // Initialize all settlorsPanels with their FormGroup already created
    this.getSettlors().controls.forEach((_, i) => {
      if (!this.settlorsPanels[i]) {
        this.settlorsPanels[i] = this.generatePanelsForSettlor(i);
      }
    });

    this.settlorForm.valueChanges.subscribe(()=> {
      this.logErrors();
    })
    
    this.setupFormChangeListeners();
  }

  ngAfterViewInit() {
    this.settlors.forEach((_: any, i: number) => {
      this.settlorsPanels[i] = this.generatePanelsForSettlor(i);
    });
  }

  ngOnDestroy(): void {
    this.cleanupFormChangeListeners();
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.settlorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  settlorsPanels: ExpansionPanel[][] = [];

  get region(): any {
    return this.estateControlService.regionType;
  }
  get loading(): any {
    return this.notificationService.loading;
  }

  get settlors(): any {
    return this.estateControlService.settlors;
  }
  get loadingTitles(): boolean {
    return this.tabControlService.loadingTitles;
  }
  get TitleOptions(): any {
    return this.tabControlService.TitleOptions;
  }

  updateIDObject(index: number, object: any): void {
    if (!object) return;
    const currents = this.settlors;
    const latestRecord = currents[index];
    let updatedRecord = {
      ...latestRecord,
      IDNoImage: object
    };

    Object.assign(currents[index], updatedRecord);
    this.estateControlService.updateRecord(1, currents);
  }
  updateKraObject(index: number, object: any): void {
    if (!object) return;
    const currents = this.settlors;
    const latestRecord = currents[index];
    let updatedRecord = {
      ...latestRecord,
      KraPinImage: object
    };

    Object.assign(currents[index], updatedRecord);
    this.estateControlService.updateRecord(1, currents);
  }
  updatePhotoObject(index: number, object: any): void {
    if (!object) return;
    const currents = this.settlors;
    const latestRecord = currents[index];
    let updatedRecord = {
      ...latestRecord,
      PassportImage: object
    };

    Object.assign(currents[index], updatedRecord);
    this.estateControlService.updateRecord(1, currents);
  }

  async populateData(): Promise<void> {
    if (this.TitleOptions.length === 0) {
      this.tabControlService.loadingTitles = true;
      await this.tabControlService.getTitlesList();
      this.tabControlService.loadingTitles = false;
    }
  }

  async populateForm(): Promise<void> {
    if (this.settlors && this.settlors.length > 0) {
      let settle = this.settlors;

      settle.forEach(async (settlor: any, index: number) => {
        if (index > 0 && !settlor.verified) {
          settle.splice(index, 1);
          await this.estateControlService.updateRecord(1, settle);
        }
      });

      if (this.settlors[0]?.verified) {
        this.consentProvided = true;
        const settlorsArray = this.settlorForm.get('settlors') as FormArray;

        // Clear existing settlors
        while (settlorsArray.length !== 0) {
          settlorsArray.removeAt(0);
        }
        
        // Add settlors from storage
        this.settlors.forEach((settlor: any) => {
          if (settlor.verified) settlorsArray.push(this.createSettlorsFormGroup(settlor));
        });

        if (this.settlors[0].detailsDone) this.consentProvided = true;
      }
    }
  }

  createSettlorsFormGroup(settlor: any = null): FormGroup {
    let form: FormGroup;

    if (settlor) {
      form = this._formBuilder.group({
        Title: [`${settlor.Title || ''}`],
        FirstName: [`${settlor.FirstName || ''}`, Validators.required],
        MiddleName: [`${settlor.MiddleName || ''}`,],
        LastName: [`${settlor.LastName || ''}`, Validators.required],
        Phone: [`${settlor.Phone || ''}`, Validators.required],
        SecondaryPhone: [`${settlor.SecondaryPhone || ''}`],
        Email: [`${settlor.Email || ''}`, [Validators.required, Validators.email]],
        
        IDNo: [`${settlor.IDNo || ''}`, [Validators.required, Validators.min(4)]],
        KraPin: [`${settlor.KraPin || ''}`],
        Address: [`${settlor.Address || ''}`],
        PostalAddress: [`${settlor.PostalAddress || ''}`],

        IDNoImage: [''],
        KraPinImage: [''],
        PassportImage: ['']
      });

      if (this.settlorForm && this.getSettlors().length > 0) {
        this.validationService.addOrRemove3Validators(
            true,
            form.get('Email')!,
            [Validators.required,
              Validators.email,
              createIDsValidatorEstate('EMAIL', this.getSettlors(), this.settlors)
            ]
          );
          this.validationService.addOrRemoveSpecificValidators(
            true,
            form.get('Phone')!,
            [Validators.required,
              createIDsValidatorEstate('TEL', this.getSettlors(), this.settlors)
            ]
          );
          this.validationService.addOrRemoveOneValidator(
            true,
            form.get('SecondaryPhone')!,
            [createIDsValidatorEstate('TEL', this.getSettlors(), this.settlors)]
          );

          this.validationService.addOrRemove3Validators(
            true,
            form.get('IDNo')!,
            [Validators.required,
              Validators.min(4),
              createIDsValidatorEstate('ID', this.getSettlors(), this.settlors)
            ]
          );
      }

      if (settlor.IDNoImage) {
        form.get('IDNoImage')?.setValue(settlor.IDNoImage.stringValue);
      }

      if (settlor.KraPinImage) {
        form.get('KraPinImage')?.setValue(settlor.KraPinImage.stringValue);
      }
      if (settlor.PassportImage) {
        form.get('PassportImage')?.setValue(settlor.PassportImage.stringValue);
      }

      if (settlor.verified) {
        this.otpVerified = true;
        
        form.get('KraPin')?.addValidators([Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)]);
        form.get('Address')?.addValidators([Validators.required]);
        form.get('PostalAddress')?.addValidators([Validators.required]);

        if (this.settlorForm && this.getSettlors().length > 0 && !settlor.done) {
          this.validationService.addOrRemove3Validators(
            true,
            form.get('KraPin')!,
            [Validators.required,
              Validators.pattern(/^[AP]\d{9}[A-Z]$/),
              createIDsValidatorEstate('PIN', this.getSettlors(), this.settlors)
            ]
          );
        }

        if (settlor.detailsDone) {
          this.validationService.addOrRemoveValidator(true, form.get('IDNoImage')!);
          this.validationService.addOrRemoveValidator(true, form.get('KraPinImage')!);
          this.validationService.addOrRemoveValidator(true, form.get('PassportImage')!);
        }
      }
      
    } else {
      if (
        this.settlors && this.settlors.length > 0 && !this.settlors[0].verified
      ) {
          this.estateControlService.refreshRecord(1);
      }

      this.otpVerified = false;

      let currentSettlors = this.settlors;
      let currentRecord: any = {verified: false, detailsDone: false, done: false};

      form = this._formBuilder.group({
        Title: [''],
        FirstName: ['', Validators.required],
        MiddleName: [''],
        LastName: ['', Validators.required],
        Phone: ['', Validators.required],
        SecondaryPhone: [''],
        Email: ['', [Validators.required, Validators.email]],
        
        IDNo: ['', [Validators.required, Validators.min(4)]],
        KraPin: [''],
        Address: [''],
        PostalAddress: [''],

        IDNoImage: [''],
        KraPinImage: [''],
        PassportImage: ['']
      });

      if (this.settlorForm && this.getSettlors().length > 0) {
        this.validationService.addOrRemove3Validators(
          true,
          form.get('Email')!,
          [Validators.required,
            Validators.email,
            createIDsValidatorEstate('EMAIL', this.getSettlors(), this.settlors)
          ]
        );
        this.validationService.addOrRemoveSpecificValidators(
          true,
          form.get('Phone')!,
          [Validators.required,
            createIDsValidatorEstate('TEL', this.getSettlors(), this.settlors)
          ]
        );
        this.validationService.addOrRemoveOneValidator(
          true,
          form.get('SecondaryPhone')!,
          [createIDsValidatorEstate('TEL', this.getSettlors(), this.settlors)]
        );

        this.validationService.addOrRemove3Validators(
          true,
          form.get('IDNo')!,
          [Validators.required,
            Validators.min(4),
            createIDsValidatorEstate('ID', this.getSettlors(), this.settlors)
          ]
        );
      }

      if (
        this.settlors.length == 0 ||
        this.settlors.length > 0 && this.settlors[this.settlors.length-1].done
      ) {
        currentSettlors.push(currentRecord);
        this.estateControlService.updateRecord(1, currentSettlors);
      }
      
    }
    form.updateValueAndValidity();

    setTimeout(() => {
      this.cdr.detectChanges();
    });
    return form;
  };

  async addNewSettlor() {
    const fields = this.settlorForm.get('settlors') as FormArray;
    const newFormGroup = this.createSettlorsFormGroup(); // creates FormGroup
    fields.push(newFormGroup); // adds to FormArray
    this.settlorForm.setControl('settlors', fields); // update form

    // Wait for view to update
    await new Promise(resolve => setTimeout(resolve));
    const newIndex = fields.length - 1;
    this.settlorsPanels[newIndex] = this.generatePanelsForSettlor(newIndex);

    // Set up listeners after panels are generated
    this.setupFormChangeListenersForIndex(newIndex);
    this.cdr.detectChanges();
  }
  
  async removeSettlor(i:number) {
    this.currentIndex = i;
    const fields = this.settlorForm.get('settlors') as FormArray;
    let currentSettlors = this.settlors;
    
    if (currentSettlors[i]) {
      if (currentSettlors[i].SettlorID) {
        this.removeButtonText = 'Removing Settlor';
        this.loadingRemove = true;
        
        try {
          if (this.estateControlService.TrustID === null) {
            console.log('Relevant IDs not found');
          } else {
            const result = await this.estateControlService.removeRecord(
              'settlor',
              currentSettlors[i].SettlorID,
              Number.parseInt(this.estateControlService.TrustID),
              environment.baseUrl + Constants.privateSettlorURL
            );
  
            if (result == 1) {
              this.notificationService.viewToast('success', 'Settlor removed successfully');
              fields.removeAt(i);
              // Remove settlor at index
              currentSettlors.splice(i, 1);;
              await this.estateControlService.updateRecord(1, currentSettlors);
            } else {
              this.notificationService.viewToast('error', 'Error removing record');
            }
          }
        } catch (error) {
          console.log(':: Error !! ', error);
        }
        this.removeButtonText = 'Remove Settlor';
        this.loadingRemove = false;
      } else {
        // Remove settlor at index
        currentSettlors.splice(i, 1);;
        await this.estateControlService.updateRecord(1, currentSettlors);
        fields.removeAt(i);
      }

    } else {
      fields.removeAt(i);
    }

    if (this.getSettlors().length < 1) this.addNewSettlor();
    setTimeout(()=> {
      this.generatePanelsForSettlor(i);
      this.settlors.forEach((settlor: any, index: number) => {
        this.updateContactInfoDoneStatus(index, settlor);
      });
    })
  }
  getSettlors() : FormArray {  
    return this.settlorForm.get("settlors") as FormArray  
  }
  getSettlorFormGroup(index: number): FormGroup {
    const settlors = this.settlorForm.get('settlors') as FormArray;
    return settlors.at(index) as FormGroup;
  }

  async openOtpModal(index?: number) {
    this.loadingText = 'Requesting OTP';
    this.notificationService.isLoading(true);

    try {
      const records = this.settlorForm.controls['settlors'].value;
      const currentIndex = index ?? records.length-1;

      let data = {
        Region: this.region,
        FirstName: records[currentIndex].FirstName,
        LastName: records[currentIndex].LastName,
        Phone: records[currentIndex].Phone,
        Email: records[currentIndex].Email,
        MileleType: 'estate'
      };

      let savedTime = this.estateControlService.OTPRequestStats;
      let response = {Status: 0, Message: 'Initialized'};

      this.estateControlService.OTPValid = checkTime(savedTime.time);

      if (this.estateControlService.OTPValid && savedTime.phone === data.Phone) {
        response.Status = 1;
        response.Message = 'Current OTP is still Valid';

      } else {
        response = await this.apiService.postRequest(
          environment.baseUrl + Constants.otpRequestURL, data);
      }

      if (response.Status === 1) {
        let currentSettlors = this.settlors;
        let currentRecord = currentSettlors[currentIndex];

        currentRecord = {...currentRecord, ...records[currentIndex]};
        
        Object.assign(currentSettlors[currentIndex], currentRecord);
        await this.estateControlService.updateRecord(1, currentSettlors);
        
        if (this.estateControlService.OTPValid) {
          this.notificationService.viewToast(
            'info',
            `Please enter the OTP that was sent to your ${this.region === 1 ? 'Email' : 'Phone / Email'}` );
        } else {
          const timeStats = {time: Date.now() / 1000, phone: data.Phone};
          this.estateControlService.OTPRequestStats = timeStats;
          this.estateControlService.OTPValid = true;

          if (this.region == 1) { // Diaspora
            this.notificationService.viewToast(
              'success',
              `OTP sent to ${data.Email}.`);
          } else {
            this.notificationService.viewToast(
              'success',
              `OTP sent to ${data.Phone}.`,
              'We have also sent it to the provided Email');
          }

        }

        this.estateControlService.OTPRequestPage = 'SettlorEstate';
        this.estateControlService.OTPIndex = currentIndex;
        
        this.loadingText = 'Verify Details';

        const dialogRef = this.dialog.open(OtpPopupComponent, {
          disableClose: true,
        });
    
        dialogRef.componentInstance.otpVerified.subscribe((value: boolean) => {
          this.otpVerified = value;
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (this.otpVerified) {
            let currentSettlors = this.settlors;
            let currentRecord = currentSettlors[currentIndex];
            currentRecord.verified = true;

            Object.assign(currentSettlors[currentIndex], currentRecord);
            this.estateControlService.updateRecord(1, currentSettlors);

            if (this.settlors.length <= 1) this.submitForm();
            else {
              this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(currentIndex).get('Address')!);
              this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(currentIndex).get('PostalAddress')!);

              if (currentIndex > 0) {
                this.validationService.addOrRemove3Validators(
                  true,
                  this.getSettlorFormGroup(currentIndex).get('KraPin')!,
                  [Validators.required,
                    Validators.pattern(/^[AP]\d{9}[A-Z]$/),
                    createIDsValidatorEstate('PIN', this.getSettlors(), this.settlors)
                  ]
                );
              } else {
                this.validationService.addOrRemoveSpecificValidators(
                  true,
                  this.getSettlorFormGroup(currentIndex).get('KraPin')!,
                  [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)]
                );
              }

              this.updateContactInfoDoneStatus(currentIndex, currentRecord);
              this.getSettlorFormGroup(currentIndex).get('Address')?.updateValueAndValidity();
              this.getSettlorFormGroup(currentIndex).get('PostalAddress')?.updateValueAndValidity();
              this.getSettlorFormGroup(currentIndex).get('KraPin')?.updateValueAndValidity();

              setTimeout(()=> {  
                this.cdr.detectChanges();
              })
            }

          } else {
            this.notificationService.viewToast('warning', 'Please verify your details to proceed');
          }
        });
      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error(':: Error !! ', error);
      this.notificationService.viewToast('error', 'OTP request failed');

    }
    this.notificationService.isLoading(false);
  }

  async saveSettlor(index?: any): Promise<void> {
    if (index || this.settlors[this.settlors.length-1].verified)
      this.loadingText = 'Updating Settlor';
    else this.loadingText = 'Saving Settlor';

    let tsMessage = 'Settlor details saved';

    this.notificationService.isLoading(true);

    try {
      const settlors = this.settlorForm.get('settlors') as FormArray;
      const currentIndex = index ?? settlors.length - 1;

      const record: FormGroup = this.getSettlorFormGroup(currentIndex) as FormGroup;

      let category;
      if (this.estateControlService.TrustID === null || currentIndex == 0) {
        category = 'Primary Settler';
      } else {
        category = 'Secondary Settler';
      }
      
      let data = {
        ...record.getRawValue(),
        TrustID: this.estateControlService.TrustID,
        Category: category
      };

      let currentSettlors = this.settlors;
      
      if (currentSettlors[currentIndex].detailsDone) {
        data.IDNoImage = this.settlors[currentIndex].IDNoImage;
        data.KraPinImage = this.settlors[currentIndex].KraPinImage;
        data.PassportImage = this.settlors[currentIndex].PassportImage;
      } else {
        data.IDNoImage = {name: '', stringValue: ''};
        data.KraPinImage = {name: '', stringValue: ''};
        data.PassportImage = {name: '', stringValue: ''};
      }

      if (currentSettlors[currentIndex].SettlorID) {
        data = {...data, SettlorID: currentSettlors[currentIndex].SettlorID};
      }
      
      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.privateSettlorURL, data, false);
      
      if (response.Status === 1) {
        if (this.estateControlService.TrustID === null) {
          this.estateControlService.TrustID = response.TrustID;
          if (!this.estateControlService.payment.done)
            this.estateControlService.updatePrivateTrustProgress('Settlors');
        }

        const latestRecord = currentSettlors[currentIndex];
        // remove images from record to NOT replace object images!!!
        const recordValueWithoutImages = Object.fromEntries(
          Object.entries(record.getRawValue()).filter(([key]) => !key.includes('Image'))
        );

        let updatedRecord = {
          ...latestRecord,
          ...recordValueWithoutImages,
          SettlorID: response.SettlorID, Category: category
        };

        Object.assign(currentSettlors[currentIndex], updatedRecord);

        await this.estateControlService.updateRecord(1, currentSettlors);
        

        currentSettlors = this.settlors;
        let currentRecord = currentSettlors[currentIndex];
        
        if (currentRecord.detailsDone) { // uploaded docs
          tsMessage = 'Settlor details updated';

          if (response.IdURL) {
            this.estateControlService.removeFromDocSummary('ID', 'Settlor', currentRecord.SettlorID);
            this.estateControlService.updateDocSummary(response.IdURL);
            currentRecord = {...currentRecord, IDURL: response.IdURL, SavedID: currentRecord.IDNoImage};
          }
          if (response.KraURL) {
            this.estateControlService.removeFromDocSummary('PIN', 'Settlor', currentRecord.SettlorID);
            this.estateControlService.updateDocSummary(response.KraURL);
            currentRecord = {...currentRecord, KraURL: response.KraURL, SavedPIN: currentRecord.KraPinImage};
          }
          if (response.PassportURL) {
            this.estateControlService.removeFromDocSummary('PASSPORT', 'Settlor', currentRecord.SettlorID);
            this.estateControlService.updateDocSummary(response.PassportURL);
            currentRecord = {...currentRecord, PassportURL: response.PassportURL, SavedPassport: currentRecord.PassportImage};
          }
          
          currentRecord.done = true;

        } else {
          currentRecord.detailsDone = true;
          this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(currentIndex).get('IDNoImage')!);
          this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(currentIndex).get('KraPinImage')!);
          this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(currentIndex).get('PassportImage')!); 
          this.getSettlorFormGroup(currentIndex).get('IDNoImage')?.updateValueAndValidity();
          this.getSettlorFormGroup(currentIndex).get('KraPinImage')?.updateValueAndValidity();
          this.getSettlorFormGroup(currentIndex).get('PassportImage')?.updateValueAndValidity();
        }
        setTimeout(() => {
          this.cdr.detectChanges();
        });

        Object.assign(currentSettlors[currentIndex], currentRecord);
        await this.estateControlService.updateRecord(1, currentSettlors);
        this.notificationService.viewToast('success', tsMessage);
        this.updateContactInfoDoneStatus(currentIndex, currentRecord)
        
        if (!environment.production) console.log('>> New Settlors !! \n', this.estateControlService.settlors);  
      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error(':: saveSettlor : ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
    this.notificationService.isLoading(false);
  }

  async submitForm(): Promise<void> {
    if (this.settlors[this.settlors.length-1].done) {
      this.navigateFunction();
    } else {
      if (this.settlors[this.settlors.length-1].verified) {
        if (this.settlors.length <= 1 && !this.consentProvided) this.openConsentForm();
        else this.saveSettlor();
      } else {
        this.openOtpModal();
      }
    }
  }
  async navigateFunction(): Promise<void> {
    await this.estateControlService.changeTab(2);
    this.estateControlService.page1Done = true;
  }

  async updateRecord(index: number) {
    await this.saveSettlor(index);
  }

  // ==============  CONSENT LOGIC   =================
  openConsentForm = () => {
    const user: ConsentClient = {
      FirstName: this.settlors[0]?.FirstName || '',
      LastName: this.settlors[0]?.LastName || '',
      Phone: this.settlors[0]?.Phone || '',
      IDNo: this.settlors[0]?.IDNo || ''
    };

    const consentData = {
      channelId: environment.channelID,
      client: user,
      appId: environment.appID,
      appPass: environment.appPass,
      consentSource: 'Milele Trust Microsite',
      company: 'ILTC',
      persist: false,
      onSubmit: (selectedConsents: ConsentItem[], allConsents: ConsentItem[]) => {
        let allAccepted = true;
        let notAccepted: ConsentItem[] = [];

        allConsents.forEach((consent: ConsentItem) => {
          if (!consent.selected && consent.mandatory) {
            allAccepted = false;
            notAccepted.push(consent);
          }
        })

        if (allAccepted) {
          this.notificationService.viewToast('success', 'Thank you');
          this.consentAndNavigate();

        } else {
          let skippedConsents = notAccepted[0].name;
          if (notAccepted.length > 1) {
            notAccepted.forEach((consent: ConsentItem, index: number) => {
              if (index > 0) {
                if (index == notAccepted.length-1) skippedConsents+= ` & ${consent.name}`;
                else skippedConsents+= `, ${consent.name}`;
              }
            })
          }
          
          // Notify user omitted required consent(s)
          this.notificationService.viewToast(
            'error',
            `You need to agree to the below consent ${(notAccepted.length === 1 ? 'item' : 'items')} in order to proceed`,
            skippedConsents,
            true
          );
        }
      },
      onClose: () => {
        // Handle when user closes without submitting
        this.notificationService.viewToast(
          'error',
          'Action Required',
          'Please accept the mandatory terms of service to continue',
          true
        );
      }
    };

    this.consentService.loadConsentForm(consentData);
  }

  consentAndNavigate = async() => {
    this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(this.settlors.length - 1).get('Address')!);
    this.validationService.addOrRemoveValidator(true, this.getSettlorFormGroup(this.settlors.length - 1).get('PostalAddress')!);

    if (this.settlorForm && this.getSettlors().length > 0) {
      this.validationService.addOrRemove3Validators(
        true,
        this.getSettlorFormGroup(this.settlors.length - 1).get('KraPin')!,
        [Validators.required,
          Validators.pattern(/^[AP]\d{9}[A-Z]$/),
          createIDsValidatorEstate('PIN', this.getSettlors(), this.settlors)
        ]
      );
    } else {
      this.validationService.addOrRemoveSpecificValidators(
        true,
        this.getSettlorFormGroup(this.settlors.length - 1).get('KraPin')!,
        [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)]
      );
    }

    this.getSettlorFormGroup(this.settlors.length - 1).get('Address')?.updateValueAndValidity();
    this.getSettlorFormGroup(this.settlors.length - 1).get('PostalAddress')?.updateValueAndValidity();
    this.getSettlorFormGroup(this.settlors.length - 1).get('KraPin')?.updateValueAndValidity();
    setTimeout(() => {
      this.cdr.detectChanges();
    });
    this.consentProvided = true;
    this.consentService.closeConsentForm();
    this.updateContactInfoDoneStatus(this.settlors.length - 1, this.settlors[this.settlors.length - 1]);
  }

  // ==============  EXPANSION SECTION   =================
  @ViewChild('contactInfo') contactInfo!: TemplateRef<any>;
  @ViewChild('details') details!: TemplateRef<any>;
  @ViewChild('uploadDocs') uploadDocs!: TemplateRef<any>;

  generatePanelsForSettlor = (i: number): ExpansionPanel[] => {
    // Fallback if templates not ready
    if (!this.contactInfo || !this.details || !this.uploadDocs || !this.settlors[i]) {
      return [];
    }
    return [
      {
        title: 'Contact Information',
        contentTemplate: this.contactInfo,
        context: { index: i },
        expanded: !(this.settlors[i].verified),
        done: (this.settlors[i].verified)
      },
      {
        title: 'Details',
        contentTemplate: this.details,
        context: { index: i },
        disabled: !(this.settlors[i].verified && this.consentProvided),
        expanded: (this.settlors[i].verified && this.consentProvided && !this.settlors[i].detailsDone),
        done: (this.settlors[i].detailsDone)
      },
      {
        title: 'Upload Documents',
        contentTemplate: this.uploadDocs,
        context: { index: i },
        disabled: !(this.settlors[i].detailsDone),
        expanded: (this.settlors[i].detailsDone && !this.settlors[i].done),
        done: (this.settlors[i].done)
      }
    ];
  }

  updateContactInfoDoneStatus(i: number, value: any) {
    // Ensure panels array exists
    this.settlorsPanels = this.settlorsPanels || [];
    
    // Initialize if missing or invalid
    if (this.settlorsPanels[i]?.length !== 3) {
      this.settlorsPanels[i] = this.generatePanelsForSettlor(i);
    }

    const panels = this.settlorsPanels[i];
    
    // Update panel states while preserving context
    if (panels[0]) {
      panels[0].done = value.verified && this.consentProvided;
      // Preserve existing context or initialize if missing
      panels[0].context = panels[0].context || { index: i };
      panels[0].expanded = !value.verified;
    }
    
    if (panels[1]) {
      panels[1].done = value.detailsDone;
      panels[1].context = panels[1].context || { index: i };
      if (value.verified && this.consentProvided) {
        panels[1].disabled = false;
        panels[1].expanded = !value.detailsDone;
      }
    }
    
    if (panels[2]) {
      panels[2].done = value.done;
      panels[2].context = panels[2].context || { index: i };
      panels[2].disabled = !value.detailsDone;
      panels[2].expanded = !value.done;
    }

    setTimeout(()=> {
      try {
        if (value.SettlorID && !value.done && i == this.settlors.length-1) {
          this.notificationService.viewToast(
            'info',
            `Settlor ${value.FirstName} ${value.LastName}`,
            `Please continue to ${
              value.detailsDone ? panels[2].title :
              'add your ' +panels[1].title
            }`
          );
        }
      } catch (error) {}
    })
  }

  private setupFormChangeListeners() {
    // Clean up any existing subscriptions
    this.cleanupFormChangeListeners();
    
    // Set up new listeners for each form group
    this.getSettlors().controls.forEach((control, index) => {
      const subscription = (control as FormGroup).valueChanges.subscribe(() => {
        // This will trigger change detection when any form value changes
        this.cdr.detectChanges();
      });
      this.formChangesSubscription.push(subscription);
    });
  }
  private setupFormChangeListenersForIndex(index: number) {
    // Clean up existing subscription if any
    const existingSub = this.formChangesSubscription[index];
    if (existingSub) {
      existingSub.unsubscribe();
    }
  }
  private cleanupFormChangeListeners() {
    this.formChangesSubscription.forEach(sub => sub.unsubscribe());
    this.formChangesSubscription = [];
  }
  
  private readonly loggedErrors = new Set<string>();

  confirmFormMatchesRecord(index: number): boolean {
    try {
      const settlor = this.settlors[index];
      const formGroup = this.getSettlorFormGroup(index);
      
      if (!settlor?.done || !formGroup) {
        const errorKey = `new-unsaved-${index}`;
        if (!this.loggedErrors.has(errorKey)) {
          console.debug('New unsaved settlor at index', index);
          this.loggedErrors.add(errorKey);
        }
        return true;
      }

      // Fields to compare
      const fieldsToCompare = [
        'Title', 'FirstName', 'MiddleName', 'LastName', 
        'Phone', 'SecondaryPhone', 'Email', 'IDNo', 'KraPin',
        'Address', 'PostalAddress'
      ];

      // Track mismatches for debugging
      const mismatches: {field: string, formValue: any, recordValue: any}[] = [];

      // Compare all relevant fields
      const basicFieldsMatch = fieldsToCompare.every(field => {
        const recordValue = settlor[field];
        const formValue = formGroup.get(field)?.value;
        const valuesMatch = (formValue || '') === (recordValue || '');
        
        if (!valuesMatch) {
          mismatches.push({
            field,
            formValue,
            recordValue
          });
        }
        // If either value is empty, consider this field as matching
        return valuesMatch;
      });

      // Check file fields
      const fileMismatches: {field: string, formValue: any, recordValue: any, matches: boolean}[] = [];
      const idMatches = settlor.IDNoImage.name === settlor.SavedID.name;
      const kraMatches = settlor.KraPinImage.name === settlor.SavedPIN.name;
      const passportMatches = settlor.PassportImage.name === settlor.SavedPassport.name;

      const filesMatch = idMatches && kraMatches && passportMatches;

      if (!filesMatch) {
        fileMismatches.push({
          field: 'IDNoImage',
          formValue: settlor.IDNoImage.name,
          recordValue: settlor.SavedID.name,
          matches: idMatches
        }, {
          field: 'KraPinImage',
          formValue: settlor.KraPinImage.name,
          recordValue: settlor.SavedPIN.name,
          matches: kraMatches
        }, {
          field: 'PassportImage',
          formValue: settlor.PassportImage.name,
          recordValue: settlor.SavedPassport.name,
          matches: passportMatches
        });
      }

      // Log mismatches only if they exist and in debug mode
      if ((mismatches.length > 0 || fileMismatches.length > 0) && !environment.production) {
        const mismatchKey = `mismatch-${index}-${JSON.stringify(mismatches)}-${JSON.stringify(fileMismatches)}`;
        if (!this.loggedErrors.has(mismatchKey)) {
          console.groupCollapsed(`Form mismatch for settlor ${(index+1)}`);
          if (mismatches.length > 0) {
            console.log('Field mismatches:', mismatches);
          }
          if (fileMismatches.length > 0) {
            console.log('File mismatches:', fileMismatches);
          }
          console.groupEnd();
          this.loggedErrors.add(mismatchKey);
        }
      }

      return basicFieldsMatch && filesMatch;
    } catch (error: any) {
      const errorKey = `error-${index}-${error.message}`;
      if (!this.loggedErrors.has(errorKey)) {
        console.error('Error in confirmFormMatchesRecord:', error);
        this.loggedErrors.add(errorKey);
      }
      return false;
    }
  }
}
